import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ICountriesState } from "./slice";
import { getCountriesAsync } from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<ICountriesState>) => void;

export const getCountriesReducer: Reducer = (builder) => {
  builder.addCase(getCountriesAsync.pending, (state) => {
    state.countries.isLoading = true;
  });

  builder.addCase(getCountriesAsync.fulfilled, (state, actions) => {
    state.countries.isLoading = false;
    state.countries.items = actions.payload;
  });

  builder.addCase(getCountriesAsync.rejected, (state) => {
    state.countries.isLoading = false;
    state.countries.items = [];
  });
};
